import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Card from "../common/Card.jsx";
import OrganizerDetails from "./OrganizerDetails.jsx";
import CloseIcon from "@mui/icons-material/Close";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { Global } from "@emotion/react";
import Overflow from "react-overflow-indicator";
import { getBrowserScrollbarWidth } from "../utils/Utils.js";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
export default function MultipleOrganizers({ organizers }) {
  const [openModal, setOpenModal] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [scrollbarWidth, setScrollbarWidth] = useState(0);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const small = useMediaQuery(theme.breakpoints.down("sm"));
  var hostname = Tickets.appPath;

  useEffect(() => {
    const scrollbar = getBrowserScrollbarWidth();
    setScrollbarWidth(scrollbar);
    setLoading(false);
  }, [fullScreen]);

  //deactivate scrollbar when opened
  if (openModal || openDrawer) {
    document.documentElement.style.overflow = "hidden";
    const navTabs = document.querySelector(".tabsContainer");
    if (!fullScreen) {
      document.querySelector("body").style.marginRight = `${scrollbarWidth}px`;
      if (navTabs) {
        navTabs.style.marginRight = `${scrollbarWidth}px`;
      }
    }
  } else {
    const navTabs = document.querySelector(".tabsContainer");
    document.documentElement.style.overflow = "auto";
    document.querySelector("body").style.marginRight = "0";
    if (navTabs) {
      navTabs.style.marginRight = "0";
    }
  }

  const handleClose = () => {
    Intercom("update", { hide_default_launcher: false });
    document.documentElement.style.overflow = "auto";
    document.querySelector("body").style.marginRight = "0";
    const navTabs = document.querySelector(".tabsContainer");
    if (navTabs) {
      document.querySelector(".tabsContainer").style.marginRight = "0";
    }
    setOpenModal(false);
    setOpenDrawer(false);
  };

  const handleViewList = () => {
    Intercom("update", { hide_default_launcher: true });
    document.documentElement.style.overflow = "hidden";
    if (fullScreen) {
      setOpenDrawer(true);
      setOpenModal(false);
    }
    if (!fullScreen) {
      setOpenModal(true);
      setOpenDrawer(false);
    }
  };

  const renderOrganizers = (organizers) => (
    <>
      {organizers?.map((organizer, index) => (
        <Card key={index} noMargin={index === organizers.length - 1}>
          <OrganizerDetails organizer={organizer} />
        </Card>
      ))}
    </>
  );

  const drawerBleeding = 88;
  const Root = styled("div")(() => ({
    height: "100%",
  }));
  const StyledBox = styled(Box)(() => ({
    backgroundColor: "#fff",
  }));

  const Puller = styled(Box)(() => ({
    width: 48,
    height: 4,
    backgroundColor: "#701bff",
    borderRadius: 3,
    position: "absolute",
    top: 16,
    left: "calc(50% - 24px)",
  }));

  const GradientOverlay = styled("div")({
    content: '""',
    position: "absolute",
    left: "24px",
    right: "24px",
    bottom: 0,
    height: "95px",
    background:
      "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.48) 23.96%, #FFF 65.63%)",
  });

  return (
    <Root>
      <CssBaseline />
      <Global
        styles={{
          ".MuiDrawer-root > .MuiPaper-root": {
            height: `calc(100% - ${drawerBleeding}px)`,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            "*::-webkit-scrollbar": {
              width: "7px",
            },
            "*::-webkit-scrollbar-track": {},
            "*::-webkit-scrollbar-thumb": {
              backgroundColor: "#CFD1D1",
              borderRadius: "5px ",
            },
            "*::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#703EFF",
            },
          },
          ".MuiDialog-paper": {
            "*::-webkit-scrollbar": {
              width: "7px",
            },
            "*::-webkit-scrollbar-track": {},
            "*::-webkit-scrollbar-thumb": {
              backgroundColor: "#CFD1D1",
              borderRadius: "5px ",
            },
            "*::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#703EFF",
            },
          },
          ".MuiDialogTitle-root": {
            padding: "24px !important",
          },
        }}
      />
      <div>
        {small ? (
          <div id="r_OrganizerContainerMain" className="r_multipleOrganizers">
            <p className="r_organizerTitle">
              {playdetailsv2_resources.Organizers}
            </p>
            <img
              src={hostname + "Site/images/icons/Eventpage/multipleCards.svg"}
            />
            <p className="r_multipleOrganizersInfoText">
              {playdetailsv2_resources.HasMultipleOrganizers}
            </p>
            <p className="r_viewOrganizerList" onClick={handleViewList}>
              {playdetailsv2_resources.ViewOrganizerList}
            </p>
          </div>
        ) : (
          <div id="r_OrganizerContainerMain" className="r_multipleOrganizers">
            <div className="r_multipleOrganizersColumn">
              <p className="r_organizerTitle">
                {playdetailsv2_resources.Organizers}
              </p>
              <p className="r_multipleOrganizersInfoText">
                {playdetailsv2_resources.HasMultipleOrganizers}
              </p>
              <p className="r_viewOrganizerList" onClick={handleViewList}>
                {playdetailsv2_resources.ViewOrganizerList}
              </p>
            </div>
            <div className="r_multipleOrganizersColumn">
              <img
                src={hostname + "Site/images/icons/Eventpage/multipleCards.svg"}
              />
            </div>
          </div>
        )}
        {fullScreen ? (
          <SwipeableDrawer
            anchor="bottom"
            open={openDrawer}
            onOpen={handleViewList}
            onClose={handleClose}
            disableSwipeToOpen={false}
            ModalProps={{
              keepMounted: true,
              disableScrollLock: true,
            }}
            PaperProps={{
              sx: {
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
              },
            }}
          >
            <StyledBox
              sx={{
                top: -drawerBleeding,
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
                visibility: "visible",
                right: 0,
                left: 0,
              }}
            >
              <Puller />
              <div className="r_drawerTitle r_organizersModal">
                <SkeletonTheme
                  baseColor="#D8DBE0"
                  highlightColor="#EDF1F6"
                  borderRadius={"4px"}
                >
                  {loading ? (
                    <Skeleton wrapper={Box} width={160} height={31} />
                  ) : (
                    <div className="r_dialogTitleText">
                      {playdetailsv2_resources.Organizers}
                    </div>
                  )}
                </SkeletonTheme>
              </div>
            </StyledBox>

            <StyledBox
              sx={{
                px: 2,
                pb: 2,
                overflow: "auto",
              }}
            >
              {renderOrganizers(organizers)}
            </StyledBox>
          </SwipeableDrawer>
        ) : (
          <Dialog
            open={openModal}
            onOpen={handleViewList}
            onClose={handleClose}
            aria-labelledby="organizers"
            PaperProps={{
              sx: {
                bgcolor: "white",
                maxWidth: "revert",
                width: 1212,
                maxHeight: "489px",
                borderRadius: "8px",
              },
            }}
          >
            <Overflow style={{ maxHeight: "489px" }}>
              <DialogTitle className="r_dialogTitle r_organizersModal">
                <SkeletonTheme
                  baseColor="#D8DBE0"
                  highlightColor="#EDF1F6"
                  borderRadius={"4px"}
                >
                  {loading ? (
                    <Skeleton wrapper={Box} width={160} height={31} />
                  ) : (
                    <div className="r_dialogTitleText">
                      {playdetailsv2_resources.Organizers}
                    </div>
                  )}
                </SkeletonTheme>
                <CloseIcon
                  onClick={handleClose}
                  className="r_dialogTitleIcon"
                />
              </DialogTitle>
              <Overflow.Content>
                <DialogContent>{renderOrganizers(organizers)}</DialogContent>
              </Overflow.Content>
              <Overflow.Indicator direction="down">
                <GradientOverlay />
              </Overflow.Indicator>
            </Overflow>
          </Dialog>
        )}
      </div>
    </Root>
  );
}
